import inViewAttr from '../../classes/inViewAttribute';
import setExternalLink from '../../components/externalLinkTooltip';
import recordEvent from '../../components/recordEvent';


export default function initGlobalComponents() {

  setExternalLink();

  document.querySelectorAll('[data-event-trigger]').forEach(
    el => new recordEvent(el));

  /**
   * Load the Hubspot form module if the component is found on the page.
   */
  if (document.querySelector('[data-cl-hubspot-form]'))
    import('../../modules/components/hubspotForm');

  document.querySelectorAll('[data-in-view-attr]').forEach(
    imgBg => new inViewAttr(imgBg));
}
